/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('LogTimeCtrl', function($scope, Log) {
    $scope.show_logs = true;

    return Log
    .getLogs({
        login: $scope.login})
    .$promise
    .then(logs => $scope.contracts = logs.contracts).catch(function(error) {
        $scope.status    = error.status;
        return $scope.contracts = [];});
});
